import { routes, router } from "../../../app/routes";

interface BreadcrumbProps {
  showHome: boolean;
  values: { label: string; url: string | null }[];
}

export function generateHostBreadcrumbs(
  path: string,
  tenantId?: number,
  tenantName?:string,
  subscriptionId?: number,
  subscriptionName?:string,
): BreadcrumbProps {
  const idMap = new Map([["Id", tenantId?.toString() ?? ""]]);
  const subscriptionIdMap = new Map([["Id", subscriptionId?.toString() ?? ""]]);

  switch (path) {
    case router.getUrl(routes.host.index, idMap):
      return {
        showHome: true,
        values: [{ label: "Host", url: null }],
      };  
    case router.getUrl(routes.host.tenant.index, idMap):
      return {
        showHome: true,
        values: [
          { label: "Host", url: routes.host.index },
          { label: "Tenants", url: null }
        ]
      };
    case router.getUrl(routes.host.tenant.details, idMap):
      return {
        showHome: true,
        values: [
          { label: "Host", url: routes.host.index },
          { label: "Tenants", url: routes.host.tenant.index },
          {
            label: tenantName ?? "",
            url: null,
          },
        ],
    };
    case router.getUrl(routes.host.tenant.organization, idMap):
      return {
        showHome: true,
        values: [
          { label: "Host", url: routes.host.index },
          { label: "Tenants", url: routes.host.tenant.index },
          {
            label: tenantName ?? "",
            url: null,
          },
        ],
    };
    case router.getUrl(routes.host.tenant.features, idMap):
      return {
        showHome: true,
        values: [
          { label: "Host", url: routes.host.index },
          { label: "Tenants", url: routes.host.tenant.index },
          {
            label: tenantName ?? "",
            url: null,
          },
        ],
    };
    case router.getUrl(routes.host.subscription.index, subscriptionIdMap):
      return {
          showHome: true,
          values: [
            { label: "Host", url: routes.host.index },
            { label: "Subscriptions", url: null }
          ]
    };
    case router.getUrl(routes.host.subscription.details, subscriptionIdMap):
      return {
          showHome: true,
          values: [
            { label: "Host", url: routes.host.index },
            { label: "Subscriptions", url: routes.host.subscription.index },
            {
              label: subscriptionName ?? "",
              url: null,
            },
          ]
    }; 
    case router.getUrl(routes.host.subscription.history, subscriptionIdMap):
      return {
          showHome: true,
          values: [
            { label: "Host", url: routes.host.index },
            { label: "Subscriptions", url: routes.host.subscription.index },
            {
              label: subscriptionName ?? "",
              url: null,
            },
          ]
    };
    case router.getUrl(routes.host.subscription.billingInfo, subscriptionIdMap):
      return {
          showHome: true,
          values: [
            { label: "Host", url: routes.host.index },
            { label: "Subscriptions", url: routes.host.subscription.index },
            {
              label: subscriptionName ?? "",
              url: null,
            },
          ]
    }; 
  
    default:
      return { showHome: false, values: [] };
  }
}

export default generateHostBreadcrumbs;

